import { Image } from "primereact/image";
import "../stylesheets/bot-node.css";
const BotNode = (props) => {
    const { nodeData, handleClick  } = props;
    return ( <button
          className={`flex justify-content-start align-items-center gap-2 py-1 cursor-pointer node_button`}
          onClick={() => handleClick(nodeData.value)}
        >
          {nodeData.icon && (
            <Image src={nodeData.icon} alt="icon" className="mx-1" />
          )}

          <span className="node-label">{nodeData.name}</span>
        </button>
    )
}

export default BotNode;